import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import DeleteComponent from '../../action/delete.jsx';
import AddAnnouncement from "./sections/add";
import EditAnnouncement from './sections/edit';


const Announcement = () => {
    const [announcements, setAnnouncements] = useState([]);
    const [announcementId, setAnnouncementId] = useState(null);

    useEffect(() => {
        fetchAnnouncements();
    }, []);

    const fetchAnnouncements = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/announcements`);
            setAnnouncements(response.data.data);
        } catch (error) {
            console.error("Error fetching announcements", error);
            setAnnouncements([]);
        }
    };

    const MAX_LENGTH = 40;
    const truncateText = (text) => {  
        return text.length > MAX_LENGTH ? text.substring(0, MAX_LENGTH) + '...' : text;  
    };
      
    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Announcements {new Date().getFullYear()}</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Announcements</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_announcement">
                                <i className="fa-solid fa-plus"></i> Add Announcement</Link>
                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Date</th>
                                                <th>Subject/Title</th>
                                                <th>Send To</th>
                                                <th>Acknowledged By</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                announcements.length > 0 ? (
                                                    announcements.map((announcement, index) => (
                                                        <tr key={announcement.id}>
                                                            <td>{++index || ''}</td>
                                                            <td>{announcement.date || ''}</td>
                                                            <td>{announcement.subject || ''}</td>
                                                            <td>{announcement.employees ? truncateText(announcement.employees) : ''}</td>
                                                            <td>
                                                                <Link to={`/acknowledgedAnnouncement/${announcement.id}`} className="btn btn-success text-white btn-sm btn-rounded mr-2">
                                                                    <i className="fa-solid fa-eye"></i> View Acknowledged
                                                                </Link>
                                                            </td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setAnnouncementId(`${announcement.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#edit_announcement_${announcement.id}`}>
                                                                                <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                            <DeleteComponent 
                                                                                url = "announcements"
                                                                                id = {announcement.id}
                                                                                fetchData={fetchAnnouncements} />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6">No records found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AddAnnouncement list={fetchAnnouncements}/>
            <EditAnnouncement list={fetchAnnouncements} announcementId={announcementId} />
        </>
    );
}

export default Announcement